export default __webpack_public_path__ + "static/media/fad-random-1dice.99f6fe6b.svg";